import styled from 'styled-components';

export const InputFieldSuffix = styled.span`
	display: block;
	padding: 5px 10px 0;
	opacity: 0.4;
`;
